"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shouldShowRightArrow = exports.shouldShowLeftArrow = exports.getMaxAnimationSize = exports.getFinalPosition = void 0;
var extractMarginWidth = function extractMarginWidth(domElement) {
  return domElement.style.borderLeftWidth + domElement.style.borderRightWidth;
};
var calculateBackAnimation = function calculateBackAnimation(arrayPositions, position, maxAnimationSize) {
  return Math.min(arrayPositions.reduce(function (acc, value, index) {
    return index < position ? acc + value : acc;
  }, 0), maxAnimationSize);
};
var getChildrenWidth = function getChildrenWidth(scroller, marginSize, sizeWhenLeftArrowAppears) {
  return Array.from(scroller.children).map(function (m) {
    return m.offsetWidth + extractMarginWidth(m);
  }).map(function (value, index) {
    return index === 0 ? value - sizeWhenLeftArrowAppears : value;
  });
};
var getMaxAnimationSize = exports.getMaxAnimationSize = function getMaxAnimationSize(scroller, marginSize) {
  var totalSize = getChildrenTotalSize(scroller, marginSize);
  var componentSize = scroller.parentNode.offsetWidth;
  return totalSize - componentSize;
};
var getFinalPosition = exports.getFinalPosition = function getFinalPosition(scroller, marginSize, sizeWhenLeftArrowAppears, messagePosition) {
  var childrenWidth = getChildrenWidth(scroller, marginSize, sizeWhenLeftArrowAppears);
  var maxAnimationSize = getMaxAnimationSize(scroller, marginSize);
  return calculateBackAnimation(childrenWidth, messagePosition, maxAnimationSize);
};
var shouldShowLeftArrow = exports.shouldShowLeftArrow = function shouldShowLeftArrow(animationPosition) {
  return animationPosition !== 0;
};
var shouldShowRightArrow = exports.shouldShowRightArrow = function shouldShowRightArrow(animationPosition, maxAnimationSize) {
  return animationPosition < maxAnimationSize;
};
var getChildrenTotalSize = function getChildrenTotalSize(messagesScroller, marginSize) {
  var messagesWidth = Array.from(messagesScroller.children).map(function (m) {
    return m.offsetWidth + 2 * marginSize;
  });
  return messagesWidth.reduce(function (sum, value) {
    return sum + value;
  });
};